<div class="cohort-editor">

  <div class="cohort-header">
    <input class="cohort-title-box" type="text" placeholder="Type the name of the cohort" [(ngModel)]="cohort.name"/>
    <div class="spacer"></div>
    <i class="fa fa-trash" (click)="onDeleteMe()" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Delete'"></i>
    <i class="fa fa-clone" (click)="onCloneMe()" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Clone'"></i>
    <i class="fa fa-check" (click)="onCloseMe()" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Close'"></i>
<!--    <i class="fa fa-bars" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Drag to change priority'"></i>-->
  </div>
  <div class="pad-left">
  </div>

  <div class="left-margin">
    <gen-dynamic-form
      [listenToDataChange]="true"
      [formData]="cohort.info"
      [formName]="cohortInfoFormName"
      [formVertical]="true"
      [updateOnBlur]="false"
      [editMode]="true"
      (formChange)="formChanged($event.form)"
      (validateChange)="validationEvent($event)">
    </gen-dynamic-form>
  </div>

  <div class="criterion-editor-list" [dragula]=listName [dragulaModel]="cohort.criteria">
    <gen-criterion-editor *ngFor="let criterion of cohort.criteria"
                          [criterion]="criterion"
                          (cloneMe)="duplicateCriterion($event)"
                          (deleteMe)="deleteCriterion($event)"
    >
    </gen-criterion-editor>
  </div>

  <div class="add-criterion-button" (click)="addBlock()">
    <div class="plus-circle"><span class="plus-sign">+</span></div>
    <div class="add-criterion-text">Add Section</div>
  </div>
</div>
